import React from 'react';
import ListResource from '../ListResource.jsx';
import ListCtrlActivates from '../ListCtrlActivates.jsx';

const api = '/api/core/tfy/deliveryTimes';

const ListDeliveryTimes = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: {},
      actions: {
        fileExport: true,
        fileImport: true,
      },
      cols: [
        {
          key: 'from.name',
          sortable: true,
          children: 'Supplier',
          headerStyle: {
            width: '45%',
          },
        },
        {
          key: 'to',
          sortable: true,
          children: 'Showroom',
          getter: (v) => `${v.orgId} - ${v.showroom}`,
        },
        {
          key: 'deliveryTime',
          getter: (v) => (v ? `${v.minWeeks}-${v.maxWeeks} Weeks` : ''),
        },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
);

export default ListDeliveryTimes;
